module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1"
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It is easy to understand how the North Carolina mountains hold secrets. There may be a waterfall around a bend, hidden deep in a pocket of rhododendron on the curve of a rocky path. Deep foliage can reveal a mossy garden in a glade with a single glance, and a bear and her family may inexplicably show up on your front lawn, frolicking under the birdfeeder. In short, it is a place that does not reveal itself all at once.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The towns of Highlands and Cashiers are deep in these mountains; they are not in the foothills where the hills are rolling and the roads are often wide. The roads here often have serious switchbacks that require drivers to slow down and notice the precarious nature of their journeys. In fact, there are no superhighways with Highlands or Cashiers as an exit (complete with a fast-food joint and a mega gas station). No, Highlands and Cashiers are about the quieter life, about vacations and escape from the everyday hustle and bustle of the cities. The towns are full of the sounds of rushing water, of cool night breezes with the windows open and of a golf ball hitting a green.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/img12.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The Highlands-Cashiers area is rich in folklore—and breathtaking views such as this one. "), _c('i', [_vm._v("Photo by the author")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Deep in these places are whispered the stories that need to be passed down. They are tales of magic, of the unexplained and of violence that traps souls still trying to make contact today. These are those stories.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b118d9e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/introduction.vue
// module id = 75
// module chunks = 0